require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./products-yoga-flow.json") })
        }
      }, "path---products-yoga-flow");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---products-yoga-flow!./.cache/json/products-yoga-flow.json
// module id = 510
// module chunks = 231608221292675